<template>
    <div class="ChatMessage" :class="participant.is_me ? '--me' : '--other'">
        <div class="message-data">
            <span class="message-data-name">
                <i class="fa fa-circle" :class="isOnline ? '--online' : '--offline'"></i>
                {{ participant.user.name }}
            </span>
            <span class="message-data-time" v-text="timestamp"></span>
            <span v-if="isSending">
                Lige nu &nbsp; <i class="fa fa-circle-o-notch fa-spin"></i>
            </span>
        </div>
        <div class="message" :class="isSending ? '--sending' : ''">
            <text-block :value="message.body"></text-block>
        </div>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

@green: @brand-success;
@blue: @brand-info;
@orange: @brand-warning;

.ChatMessage {
    .message-data {
        font-size: 14px;
        margin-bottom: 15px;
    }

    .message-data-time {
        color: lighten(@color-gray-light, 8%);
        padding-left: 6px;
    }

    .message {
        color: white;
        padding: 18px 20px;
        line-height: 26px;
        font-size: 16px;
        border-radius: 7px;
        margin-bottom: 30px;
        width: 90%;
        position: relative;

        &:after {
            bottom: 100%;
            border: solid transparent;
            content: ' ';
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-width: 10px;
            margin-left: -10px;
        }

        &.--sending {
            opacity: 0.7;
        }
    }

    &.--me {
        .message-data {
            text-align: right;
        }
        .message {
            background: @brand-primary;
            float: right;

            &:after {
                border-bottom-color: @brand-primary;
                left: 93%;
            }
        }
    }

    &.--other {
        .message {
            background: @brand-primary-light;
            color: darken(@brand-primary, 30%);

            &:after {
                border-bottom-color: @brand-primary-light;
                left: 7%;
            }
        }
    }

    .--online,
    .--offline,
    .me {
        margin: 3px;
        font-size: 11px;
        position: relative;
        top: -1px;
    }

    .--online {
        color: @green;
    }

    .--offline {
        color: @orange;
    }
}
</style>

<script type="text/babel">
import ChatProvider from 'dashboard-js/providers/ChatProvider'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'

export default {
    mixins: [HasSubscriptions],

    props: ['message', 'participant'],

    data() {
        return {
            isOnline: false,
        }
    },

    computed: {
        isSending() {
            return !this.message.created_at
        },

        timestamp() {
            return this.isSending
                ? ''
                : moment.min(moment(), moment(this.message.created_at)).fromNow()
        },
    },

    created() {
        this.subscribe(
            ChatProvider.streamOnlineStatus(this.participant),
            status => (this.isOnline = status)
        )
    },
}
</script>
